import { gql } from "@apollo/client";

const CURRENT_USER_FOR_SETTINGS = gql`
  query GetCurrentUserForSettingsPrisma {
    currentOrganization {
      id
      customer {
        id
        atsIntegration {
          id
        }
      }
      prospectOnboardingComplete
    }
    currentUserPrisma {
      id
      currentUserMembership {
        id
        hasLimitedAccess
      }
    }
  }
`;

export default CURRENT_USER_FOR_SETTINGS;
